.formGroup {
  input[type='checkbox'] {
    margin-right: 1.5rem;
    position: relative;
    top: -0.1rem;
  }
}
